import { Button, Container } from "@mui/material";
import { ImageCheck, LoadingSimpleComponent, CollaborationLink, ReportDetailLink } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import {
  ImageCheckType,
  ImageType,
  SkeletonType,
} from "Explore/Config/ImageType";
import { Drawer, Modal, Tooltip } from "antd";
import { useState } from "react";
import styles from "./BasicInformation.module.scss";
import useDeviceCheck from "Hooks/useDeviceCheck";

const BasicInformation = ({ institution_id, summary, landscape }) => {
  const { isMobile } = useDeviceCheck();
  const [seeMore, setSeeMore] = useState(false);

  const renderAvatar = () => {
    return (
      <LoadingSimpleComponent
        component={
          <ImageCheck
            url={summary?.data?.photo}
            // url={`https://media.academic.online/institutions_images/${institution_id}/${ImageType.SEAL}.png`}
            className={styles["images-seal"]}
            alt={"seal"}
            type={ImageCheckType.INSTITUTION_LOGO}
          />
        }
        type={SkeletonType.IMAGE}
        isLoading={summary.isLoading}
        className={styles["images-seal-wrapper"]}
      />
    );
  };
  if (summary.isLoading) {
    return (
      <div className={styles["basic-information"]}>
        <LoadingSimpleComponent
          type={SkeletonType.PARAGRAPH}
          isLoading={true}
          className={styles["cover-img-wrapper"]}
          rows={12}
        />
      </div>
    );
  }

  return (
    <>
      <div className={styles["basic-information"]}>
        <div className={styles["basic-information__left"]}>
          <LoadingSimpleComponent
            component={
              <ImageCheck
                url={landscape}
                className={styles["cover-img"]}
                type={ImageCheckType.INSTITUTION_LANDSCAPE}
              />
            }
            type={SkeletonType.COVER_IMAGE}
            isLoading={summary.isLoading}
            className={styles["cover-img-wrapper"]}
          />
        </div>
        <div className={styles["basic-information__right"]}>
          <Container maxWidth="lg">
            {renderAvatar()}
            <LoadingSimpleComponent
              component={
                <h1 className={styles["name"]} style={{ textAlign: "center" }}>{summary?.data.inst_name}</h1>
              }
              type={SkeletonType.INPUT}
              isLoading={summary.isLoading}
              className={styles["name"]}
            />
            <LoadingSimpleComponent
              component={
                <div className={styles["bio"]}>
                  <p
                    className={styles["bio--content"]}
                    onClick={() => setSeeMore(true)}
                  >
                    {summary.data?.biography}
                  </p>
                </div>
              }
              type={SkeletonType.PARAGRAPH}
              isLoading={summary.isLoading}
            />
            <div className={styles["more-info"]}>
              <Button
                className={`${styles["more-info--item"]}`}
                href={summary?.data?.official_web}
                target="_blank" rel="noreferrer"
              >
                <div className={styles["more-info--item--start-icon"]}>
                  {IconPack.global_outlined}
                </div>
                Official web
                <div className={styles["more-info--item--link-icon"]}>
                  {IconPack.externalLink}
                </div>
              </Button>
              {!!summary?.data?.wikipedia && (
                <Button
                  className={`${styles["more-info--item"]}`}
                  href={summary?.data?.wikipedia}
                  target="_blank" rel="noreferrer"
                >
                  Wikipedia
                  <div className={styles["more-info--item--link-icon"]}>
                    {IconPack.externalLink}
                  </div>
                </Button>
              )}
              {(() => {
                const canonicalId = summary?.data?.id || institution_id;
                const instLogo =
                  summary?.data?.photo ||
                  summary?.data?.logo_url ||
                  (summary?.data?.id && !isNaN(Number(summary.data.id))
                    ? `https://media.academic.online/institutions_images/${summary.data.id}/seal.png`
                    : undefined);
                return (
                  <>
                    <CollaborationLink
                      entity={{
                        id: canonicalId,
                        name: summary?.data?.inst_name || summary?.data?.name,
                        type: "institution",
                        photo: instLogo,
                        avatar: instLogo,
                      }}
                      className={styles["collaboration-btn"]}
                    />
                    <ReportDetailLink
                      entity={{
                        id: canonicalId,
                        name: summary?.data?.inst_name || summary?.data?.name,
                        type: "institution",
                        photo: instLogo,
                        avatar: instLogo,
                      }}
                      className={styles["collaboration-btn"]}
                    />
                  </>
                );
              })()}
            </div>
          </Container>
        </div>
      </div>

      <Modal
        title="Biography"
        placement={"bottom"}
        onCancel={() => setSeeMore(false)}
        open={seeMore}
        footer={null}
      >
        <p>{summary.data?.biography}</p>
      </Modal>
    </>
  );
};

export default BasicInformation;
